import type { BaseQueryFn } from '@reduxjs/toolkit/query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import axios from "axios";

export const axiosBaseQuery =
    (): BaseQueryFn<
        {
            url: string
            method: AxiosRequestConfig['method']
            data?: AxiosRequestConfig['data']
            params?: AxiosRequestConfig['params']
        },
        unknown,
        unknown
    > =>
        async ({ url, method, data, params }) => {
            try {
                const result = await axios({ url, method, data, params })
                return { data: result.data }
            } catch (err) {
                const axiosErr = err as AxiosError
                return {
                    error: {
                        status: axiosErr.response?.status,
                        data: axiosErr.response?.data,
                    },
                }
            }
        }
